
export abstract class BaseResourceModel {
  id?: number;
  data_cadastro?: Date;
  data_alteracao?: Date;
}
